<template>
</template>
<script>

export default {
  components: {

  },
  data: function() {
    return {}
  },
  computed: {
    type: function() {
      return this.$root.$data.pageMsg.type;
    },
    text: function() {
      return this.$root.$data.pageMsg.text;
    }
  }
}
</script>




// WEBPACK FOOTER //
// message.vue?50b0be60